<template>
  <div v-if="displayErrors.length" class="ec-error-banner">
    <i class="el-icon-warning-outline"></i>
    <div class="ec-error-banner-content">
      <p v-for="(err, idx) in displayErrors" :key="idx">{{ err }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EcErrorBanner',
  props: {
    errors: { type: [Array, String], default: () => [] },
    error: { type: [String, Array], default: '' },
  },
  computed: {
    displayErrors() {
      if (Array.isArray(this.error)) return this.error
      if (this.error) return [this.error]
      if (typeof this.errors === 'string') return [this.errors]
      return this.errors || []
    },
  },
}
</script>

<style scoped>
.ec-error-banner {
  display: flex;
  gap: 10px;
  padding: 12px 16px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  color: #991b1b;
  font-size: 0.8125rem;
}
.ec-error-banner i {
  flex-shrink: 0;
  font-size: 16px;
  margin-top: 2px;
}
.ec-error-banner-content p {
  margin: 0 0 2px;
}
</style>
